import { Dispatch } from "redux";
import { StoreAction } from "../../utils/actions";
import { CategoryColor, IEvent } from "../../app/modules/Dashboard/calendar/core/type";

/** Set full event list */
export const fetchEventAction =
    (eventData: IEvent[] | null) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.FETCH_EVENTS,
                payload: eventData,
            });
        };

export const fetchEventCategoryAndColorsAction = (categories: CategoryColor[]) => async (dispatch: Dispatch) => {
    dispatch({
        type: StoreAction.FETCH_EVENT_CATEGORY_AND_COLORS,
        payload: categories
    });
}

/** Add single event */
export const addWEventAction =
    (event: IEvent) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.ADD_EVENT,
                payload: event,
            });
        };

/** Delete event by id */
export const deleteEventAction =
    (id: string | number) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.DELETE_EVENT,
                payload: id,
            });
        };

/** Update event */
export const updateEventAction =
    (event: IEvent) =>
        async (dispatch: Dispatch) => {
            dispatch({
                type: StoreAction.UPDATE_EVENT,
                payload: event,
            });
        };